import React from "react";
import styled from "styled-components";
import { Post } from "@domain/post/post";
import { useModalTools } from "@ui/modals/modalContext";
import { gap } from "@ui/styles/utils";
import { useAuthModalBlocker } from "@ui/components/auth/useAuthModalBlocker";
import { CommentIcon, LikeIcon, RepostIcon } from "@ui/components/icons";
import { ReactionsModal } from "./reactionsModal";

interface ActionInfosProps extends React.HTMLAttributes<HTMLDivElement> {
	post: Post;
}

export const ActionInfos: React.FC<ActionInfosProps> = ({ post, ...htmlProps }) => {
	const { likes, comments, shares } = post;
	const { createModal } = useModalTools();
	const blockGuest = useAuthModalBlocker();
	return (
		<Container {...htmlProps}>
			{likes.total >= 1 && (
				<ActionInfo
					colored={likes.byMe}
					onClick={() =>
						blockGuest(() => createModal((close) => <ReactionsModal close={close} postId={post.id} reaction="likes" />))
					}
				>
					<LikeIcon />
					{likes.total}
				</ActionInfo>
			)}
			{comments.total >= 1 && (
				<ActionInfo
					onClick={() =>
						blockGuest(() =>
							createModal((close) => <ReactionsModal close={close} postId={post.id} reaction="comments" />)
						)
					}
				>
					<CommentIcon />
					{comments.total}
				</ActionInfo>
			)}
			{shares.total >= 1 && (
				<ActionInfo
					onClick={() =>
						blockGuest(() => createModal((close) => <ReactionsModal close={close} postId={post.id} reaction="share" />))
					}
				>
					<RepostIcon />
					{shares.total}
				</ActionInfo>
			)}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	${gap(25, "row")}
`;

const ActionInfo = styled.div<{ onClick?: () => void; colored?: boolean }>`
	${({ theme }) => theme.textStyles.label};
	${({ colored, theme }) => colored && `color: ${theme.colors.primary}`};
	cursor: ${({ onClick }) => (onClick ? "pointer" : "initial")};
	display: flex;
	align-items: center;
	svg {
		margin-right: 4px;
		width: 14px;
		height: 14px;

		path {
			${({ colored, theme }) => colored && `fill: ${theme.colors.primary}`};
		}
	}
`;
